import React from 'react';
import Container from "@scentregroup/ui/components/container";
import classNames from 'classnames';
import PatternSVG from '../../assets/images/pattern.inline.svg';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionHeading = _ref => {
  let {
    title,
    color
  } = _ref;
  return /*#__PURE__*/_jsxs("header", {
    className: style[color],
    "data-id": "section-heading_index_SectionHeading_header",
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(style.anglePattern, {
        [style.anglePatternGrey]: color !== 'Seasonal'
      }),
      "aria-hidden": "true",
      "data-id": "section-heading_index_SectionHeading_header_div",
      children: /*#__PURE__*/_jsx(PatternSVG, {
        "data-id": "section-heading_index_SectionHeading_div_PatternSVG"
      })
    }), /*#__PURE__*/_jsx(Container, {
      type: "large",
      className: style.container,
      "data-id": "section-heading_index_SectionHeading_header_Container",
      children: /*#__PURE__*/_jsx("h1", {
        className: style.title,
        "data-id": "section-heading_index_SectionHeading_Container_h1",
        children: title
      })
    })]
  });
};
export default SectionHeading;